webpackJsonp([273950069227526],{

/***/ 320:
/***/ (function(module, exports) {

	module.exports = {"data":{"contentfulAbout":{"phone":"647 381 1436","email":"hello@nelshuang.com","instagram":"nelshuang","aboutParagraph":{"aboutParagraph":"Aspiring Super Saiyan. My hair is black now, but contact me for further updates. \n\nToronto based Photographer.\n"}}},"pathContext":{"_PARENT":"SOURCE"}}

/***/ })

});


// WEBPACK FOOTER //
// path---about-810edfdd358cce001c7d.js